import { HEAD_ITEMS } from 'texts/bookingHistory'

export const TABLE_HEAD_ITEMS = [
  {
    value: HEAD_ITEMS.RESERVATION_NUMBER,
  },
  {
    value: HEAD_ITEMS.PARTNER_NUMBER,
  },
  {
    value: HEAD_ITEMS.STATUS,
  },
  {
    value: HEAD_ITEMS.RESERVED_DATE,
  },
  {
    value: HEAD_ITEMS.CONFIRMATION_DATE,
  },
  {
    value: HEAD_ITEMS.PICKUP_LOCATION,
  },
  {
    value: HEAD_ITEMS.PICKUP_DATE,
  },
  {
    value: HEAD_ITEMS.DROPOFF_LOCATION,
  },
  {
    value: HEAD_ITEMS.DROPOFF_DATE,
  },
  {
    value: HEAD_ITEMS.DURATION_IN_DAYS,
  },
  {
    value: HEAD_ITEMS.CAR_PRICE,
  },
  {
    value: HEAD_ITEMS.COMPANY_CLASS,
  },
  {
    value: HEAD_ITEMS.SIPP_CODE,
  },
  {
    value: HEAD_ITEMS.EQUIPMENT,
  },
  {
    value: HEAD_ITEMS.CLIENT_NAME_AND_SURNAME,
  },
]

export const BOOKING_STATUS = {
  Accept: 2,
  Cancel: 5,
}

export const BOOKING_HISTORY_COLUMN_INDEX = {
  reservationNumbers: 0,
  partnerNumber: 1,
  reservationStatuses: 2,
  reserveddate: 3,
  partnerapprovedate: 4,
  pickUpLocation: 5,
  pickupdatetime: 6,
  dropOffLocations: 7,
  dropoffdatetime: 8,
  duration: 9,
  netprice: 10,
  companyClass: 11,
  sippCode: 12,
  clientFullName: 14,
}
